import { render, staticRenderFns } from "./businessIntroduce.vue?vue&type=template&id=f4b8bd78&scoped=true"
import script from "./businessIntroduce.vue?vue&type=script&lang=js"
export * from "./businessIntroduce.vue?vue&type=script&lang=js"
import style0 from "./businessIntroduce.vue?vue&type=style&index=0&id=f4b8bd78&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b8bd78",
  null
  
)

export default component.exports